import * as yup from 'yup';

export const VitalSignSchema = yup.object({
  measurementDate: yup.date().notRequired().nullable(),
  diaValue: yup.number().notRequired().nullable(),
  sysValue: yup.number().notRequired().nullable(),
  pulseValue: yup.number().notRequired().nullable(),
  measurementTextValue: yup.string().notRequired().nullable(),
  measurementNumberValue: yup.number().notRequired().nullable(),
  remark: yup.string().notRequired().nullable(),
});

export interface IVitalSign {
  measurementDate?: Date;
  diaValue?: number;
  sysValue?: number;
  pulseValue?: number;
  measurementTextValue?: string;
  measurementNumberValue?: number;
  remark?: string;
}

export const CreateVitalSignSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(VitalSignSchema);

export interface ICreateVitalSign extends IVitalSign {
  residentId: string;
}

export const UpdateVitalSignSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(VitalSignSchema);

export interface IUpdateVitalSign extends IVitalSign {
  id: string;
}
